import Axios from "axios";

const rejectSiteVisit = async (id, token) =>
  await Axios.post(`${window.API}/site-visit/reject/${id}`, [], {
    headers: { Authorization: `Bearer ${token}` },
  });

export { rejectSiteVisit };
